import React from "react";
import type { ConfirmOptions } from "@app/services/confirm/types";
import type { ApiSpMovingData } from "@src/businessModules/Stock/api/storePlaces";
import {
    StockPlacementCancelConfirmContent,
    type StockPlacementCancelConfirmField,
} from "./StockPlacementCancelConfirmContent";

/** Параметры построения confirm-опций отмены размещения. */
export interface BuildStockPlacementCancelConfirmParams {
    /** Движение, которое будет удалено. */
    movement: ApiSpMovingData;
    /** Поля контекста строки состава. */
    fields: StockPlacementCancelConfirmField[];
}

/**
 * Формирует опции app-level confirm для отмены размещения партии.
 * @param params движение и поля контекста
 */
export function buildStockPlacementCancelConfirmOptions(params: BuildStockPlacementCancelConfirmParams): ConfirmOptions {
    const { movement, fields } = params;

    return {
        title: "Отмена размещения",
        content: <StockPlacementCancelConfirmContent movement={movement} fields={fields} />,
        confirmText: "Удалить",
        cancelText: "Закрыть",
    };
}
